import Highcharts from "highcharts"

import mapDataUS from "@highcharts/map-collection/countries/us/us-all.topo.json"

export const getLeadByStateOptions = (
  chartLabels: [string, number][]
): Highcharts.Options => ({
  ...getLeadByStateDefaultOptions(),
  colorAxis: {
    minColor: "#F4F4F4",
    maxColor: "#786FF6"
  },
  tooltip: {
    backgroundColor: "#42405A",
    borderColor: "#42405A",
    borderRadius: 5,
    shadow: false,
    style: {
      color: "#ffffff",
      fontSize: "12px",
      padding: "10px"
    },
    headerFormat: "",
    pointFormat: `<span style="font-weight: 700; padding-left: 5px">{point.name}</span><br/>
      <span>{point.value} leads</span><br/>`
  },
  series: [
    {
      type: "map",
      data: chartLabels,
      color: "#F3F4F6",
      states: {
        hover: {
          color: "#8B83FB"
        }
      }
    }
  ],
  legend: {
    align: "left",
    verticalAlign: "bottom",
    x: -15,
    y: 18
  }
})

export const getLeadByStateDefaultOptions = (): Highcharts.Options => ({
  chart: {
    map: mapDataUS
  },
  title: {
    text: undefined
  },
  series: [
    {
      type: "map",
      data: [],
      color: "#F3F4F6",
      borderColor: "#FFFFFF"
    }
  ],
  legend: {
    enabled: false
  },
  credits: {
    enabled: false // Disable the copyright notice
  }
})
